import { Component, Input, Output,EventEmitter } from '@angular/core';
import { Response, Http, Headers, RequestOptions } from '@angular/http';
import { Localization } from '../../app/app.localization';

/**
 * Generated class for the MobileOrderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
    selector: 'mobile-order',
    templateUrl: 'mobile-order.html'
})
export class MobileOrderComponent {

    @Input() service:any;
    @Output() returnEvent = new EventEmitter<any>();
    @Output() openOptions = new EventEmitter();
    @Output() hideOptions = new EventEmitter();
    showOption: boolean;
    hour: any;
    min: any;
    note: any;
    email: any;
    sms: any;
    error_msgs: string = '';
    preventSubmit: boolean;
    notificationType: any;
    receiveTimes: any;
    receive_time: any;

    loading: any;
    gmopayment: any = null;
    storeConfig: any;
    disableOption; boolean = false;

    constructor(
        private _loc: Localization,
        private _http:Http) {

        this.storeConfig = JSON.parse(localStorage.getItem("configs"));
        this.disableOption = (this.storeConfig["MOBILEORDER_NOUSE_ADDRESS"] && parseInt(this.storeConfig["MOBILEORDER_NOUSE_ADDRESS"], 0) > 0);
        this.receive_time = "";
        this.showOption = false;
        this.hour = (localStorage.getItem("hour") != "null") ? localStorage.getItem("hour") : null;
        this.min = (localStorage.getItem("min") != "null") ? localStorage.getItem("min") : null;
        this.email = (localStorage.getItem("email") != "null") ? localStorage.getItem("email") : null;
        this.sms = (localStorage.getItem("sms") != "null") ? localStorage.getItem("sms") : null;
        this.notificationType = (localStorage.getItem("notificationTYpe") != "null") ? localStorage.getItem("notificationType") : "email";
        this.note = (localStorage.getItem("note") != "null") ? localStorage.getItem("note") : null;
        this.preventSubmit = false;

        let storeConfig = JSON.parse(localStorage.getItem("configs"));
        if (storeConfig["MOBILEORDER_LEAD_TIME_MIN"] && storeConfig["MOBILEORDER_INTERVAL_TIME_MIN"] && storeConfig["MOBILEORDER_LIMIT_TIME_HOUR"] && storeConfig["MOBILEORDER_LIMIT_TIME_MIN"]) {
            var leadTimeMin = parseInt(storeConfig["MOBILEORDER_LEAD_TIME_MIN"]);
            var intervalTimeMin = parseInt(storeConfig["MOBILEORDER_INTERVAL_TIME_MIN"]);
            var limitTimeHour = storeConfig["MOBILEORDER_LIMIT_TIME_HOUR"];
            var limitTimeMin = storeConfig["MOBILEORDER_LIMIT_TIME_MIN"];

            var now = new Date();
            var minute = Math.floor((now.getMinutes() + leadTimeMin) / intervalTimeMin) * intervalTimeMin; // ((現在の分+リードタイム)➗繰り返し時間単位)✖️繰り返し時間単位
            var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), minute + intervalTimeMin);
            var dtMax = new Date(now.getFullYear(), now.getMonth(), now.getDate(), limitTimeHour, limitTimeMin);

            this.receiveTimes = [];
            while (dt.getTime() <= dtMax.getTime()) {
                this.receiveTimes.push({
                    hour: dt.getHours(),
                    min: (("0") + dt.getMinutes()).substr(-2)
                });
                dt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes() + intervalTimeMin);
            }
        } else {
            var delay = 30;
            var reserveToMin = 60 * 4;

            var now = new Date();
            var minute = (Math.floor(now.getMinutes() / 15) + 1) * 15;
            var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), minute + delay);
            var dtmax = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours(), now.getMinutes() + reserveToMin);


            var i = 0;
            this.receiveTimes = [];
            while (true) {
                this.receiveTimes.push(
                    {
                        hour: dt.getHours(),
                        min: (("0") + dt.getMinutes()).substr(-2)
                    }
                );
                dt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes() + 15);
                if (i > 100 || dt.getTime() > dtmax.getTime()) break;
                i++;
            }
        }
        // this._apiService.getGmoMultipayRequest({"MemberID":memberID, "visitor_id":visitor_id, "store_id":localStorage.getItem("store_id"),"order_no":order_no,"uiid":Config.uiid, "version":"2.5.1"}).subscribe(
        //     (result) => {
        //         localStorage.setItem("visitor_id", result.request.ClientField3);
        //         this.gmopayment = result.request;
        //         this.shopId = result.request.ShopID;
        //
        //         setTimeout(function(){
        //             this.loading.dismiss();
        //             this.paymentForm.nativeElement.submit();
        //         }.bind(this), 300);
        //     }
        // );
    }

    getValidateError(){
        
      let message = [];
      if (!this.hour || !this.min) message.push("希望受け取り時間が選択されていません");
      if (this.notificationType == "email" && (!this.email || this.email.length < 1)) message.push("Emailアドレスが入力されていません");
      if (this.notificationType == "sms" && (!this.sms || this.sms.length < 1)) message.push("SMSアドレスが入力されていません");
      return message.join("\n");
    }
    validateOptions(){
      if (!this.hour || !this.min) return false;
      if (this.notificationType == "email" && (!this.email || this.email.length < 1)) return false;
      if (this.notificationType == "sms" && (!this.sms || this.sms.length < 1)) return false;
      return true;
    }

    handleError(err){
    }

    // 備考のテキストエリアを入力した文広げる処理
    textChange() {
        const textArea = document.querySelector("textarea");
        textArea.style.overflow = 'hidden';
        textArea.style.height = 'auto';
        textArea.style.height = textArea.scrollHeight + 'px';
      }
      
    clickToOrder(){
        
        // ここでinsert Visitorしてしまう
        // this.returnEvent.emit("hello world");
        let d = new Date();
        d.setHours(parseInt(localStorage.getItem("hour"),0), parseInt(localStorage.getItem("min"), 0), 0); 
        let url_post = {
            "mobile":1,
            "mobile_email":(this.email) ? this.email : "",
            "mobile_sms":(this.sms) ? this.sms : "",
            "mobile_notification_type":(this.notificationType) ? this.notificationType : "",
            "mobile_note":(this.note) ? this.note : "",
            "mobile_user_receivetime":d.getFullYear()+"-"+(d.getMonth() + 1)+"-"+d.getDate()+" "+d.getHours()+":"+d.getMinutes()+":00",
        };
        this.returnEvent.emit(url_post);
    }


    submit() {
        let has_error = false;
        this.error_msgs = '';
        // set this variable to false if re-submission is needed
        this.preventSubmit = true;
        if (((this.email == null || this.email == 'null' || !this.email.trim().length) && this.notificationType == 'email')
            || ((this.sms == null || this.sms == 'null' || !this.sms.trim().length) && this.notificationType == 'sms')
                || this.notificationType == 'null' || this.notificationType == null) {
            this.error_msgs += this._loc.t('通知の受け取り方法を選択してください');
        this.preventSubmit = false;
        has_error = true;
        }

        if (this.receive_time.length > 0) {
            this.hour = this.receive_time.split(":")[0];
            this.min = this.receive_time.split(":")[1];
        } else {
            this.hour = "";
            this.min = "";
            if (this.error_msgs.length) {
                this.error_msgs += '<br>';
            }
            has_error = true;
            this.error_msgs += this._loc.t('お受け取り希望時間を入力してください');
            this.preventSubmit = false;
        }

        if (has_error) {
            return;
        }

        localStorage.setItem("hour", this.hour);
        localStorage.setItem("min", this.min);
        localStorage.setItem("email", this.email);
        localStorage.setItem("sms", this.sms);
        localStorage.setItem("note", this.note);
        localStorage.setItem("notificationType", this.notificationType);
        this.showOption = false;
        this.hideOptions.emit();

    }

}



// WEBPACK FOOTER //
// ./src/components/mobile-order/mobile-order.ts